import { Component, OnInit, ViewChild } from '@angular/core';
import {
    Ach,
    Confirmation,
    ConfirmationMessage,
    ConfirmationType,
    EmailAttachment,
    EmailMessage,
    Invoice,
    Order,
    PackingSlip,
    PurchaseOrder,
    Setting,
} from 'app/core/model/entity-model';
import { core } from 'breeze-client';
import { alert, confirm } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { AppInformationService, AuthService, GenesisUnitOfWork, PortalService, ReportService } from '../../core/core.module';
import _ from 'lodash';

@Component({
    selector: 'app-email-dialog',
    templateUrl: './email-dialog.component.html',
    styleUrls: ['./email-dialog.component.scss'],
    standalone: false,
})
export class EmailDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    mode = 'Invoice';
    isQuote = false; // used for sales orders
    attachInvoices = false; // used for ach links and requests
    saveEmailOnlyOnSend: boolean = false;
    entityId: any;
    dealerEmail: any;

    entity: any;
    emailAddresses: any;
    selectedAddress: any;
    email: any;
    body: any;
    emailConfirmation: boolean = false;
    sendCCTheirOwnEmail: boolean = false;
    showAttachments: boolean = false;
    showReportButton: boolean = false;
    order: Order;

    includeConfirmation: boolean = false;
    types: ConfirmationType[];
    selectedType: number;
    messages: ConfirmationMessage[];
    selectedMessage: ConfirmationMessage;

    processing = false;
    readOnly: boolean = false;

    attachments: EmailAttachment[] = [];
    attachmentFullPath = 'https://peccerium.blob.core.windows.net/genesis-trailers/emailAttachments/';
    uploadUrl = environment.serviceName + '/file/SaveEmailAttachmentToBlobStorage';
    uploadHeader: any;

    @ViewChild('inputComponent') inputComponent: any;

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private auth: AuthService,
        private portalService: PortalService,
        private appInfo: AppInformationService,
        private reportService: ReportService,
    ) {}

    async ngOnInit() {
        this.uploadHeader = { Authorization: `Bearer ${this.auth.currentUser.jwtToken}` };
        this.showAttachments = this.mode === 'PurchaseOrder';
        this.showReportButton =
            this.mode === 'PurchaseOrder' ||
            this.mode === 'SalesOrder' ||
            this.mode === 'Invoice' ||
            this.mode === 'PackingSlip' ||
            this.mode === 'ACH' ||
            this.mode === 'SalesOrderMsrps';

        if (this.email) {
            await this.getAttachments();
            return;
        }
        // if (this.emailConfirmation) {
        this.messages = (await this.uow.getConfirmationMessages()) as ConfirmationMessage[];
        this.types = this.uow.lookups.confirmationTypes as ConfirmationType[];
        // }

        this.emailAddresses = await this.uow.getEmailAddresses();
        this.email = this.uow.emailMessages.createEntity() as EmailMessage;
        this.email.to = `${!!this.dealerEmail ? this.dealerEmail : ''}`;
        this.email.created = new Date();
        this.email.createdById = this.auth.currentUser.id;

        if (this.mode === 'Invoice') {
            this.entity = await this.uow.invoices.byId(this.entityId, 'dealer.salesRep');
            this.email.invoiceId = this.entityId;
            this.email.subject = `Invoice# ${this.entity.invoiceNumber}`;
            this.email.cc = this.entity.dealer?.salesRep?.email;
            this.email.body = this.body;
        } else if (this.mode === 'PackingSlip') {
            this.entity = await this.uow.packingSlips.byId(this.entityId, 'dealer.salesRep');
            this.email.packingSlipId = this.entityId;
            this.email.subject = `PackingSlip# ${this.entity.packingSlipNumber}`;
            this.email.cc = this.entity.dealer?.salesRep?.email;
            this.email.body = this.body;
        } else if (this.mode === 'PurchaseOrder') {
            this.entity = await this.uow.purchaseOrders.byId(this.entityId);
            this.email.purchaseOrderId = this.entityId;
            this.email.subject = `PO# ${this.entity.pONumber}`;
            // this.email.body = `Please Acknowledge and advise on lead time.\r\n\r\nThanks,\r\nGenesis Trailers`;
            this.email.body = this.body;
        } else if (this.mode === 'Dealer') {
            this.email.to = 'halferink@genesistrailers.com';
            this.email.subject = 'Dealer Emails';
            this.email.body = this.body;
        } else if (this.mode === 'Warranty') {
            this.entity = await this.uow.orders.byId(this.entityId);
            this.email.salesOrderId = this.entityId;
            this.email.to = this.entity.shipToEmail;
            this.email.subject = `Warranty# ${this.entity.invoiceNumberDisplay}`;
            this.email.body = this.body;
        } else if (this.mode === 'SalesOrderMsrps') {
            this.entity = await this.uow.orders.byId(this.entityId, 'dealer, salesRep');
            this.email.salesOrderId = this.entityId;
            this.email.subject = `Sales Order # ${this.entity.invoiceNumber} MSRPs`;
            this.email.body = this.body;
            this.email.cc = this.entity.salesRep?.sendSalesOrders ? this.entity.salesRep.email : '';
            this.email.mode = 'MSRP';
        } else if (this.mode === 'ACH') {
            this.email.achId = this.entityId;
            this.email.subject = 'ACH Authorization Form';
        } else if (this.mode === 'AchLink') {
            this.email.achId = this.entityId;
            this.email.subject = 'ACH Authorization Form - ReSend';
            this.email.body = this.body;
        } else if (this.mode === 'AchRequest') {
            const subject = ((await this.uow.getSettingsByName('AchEmailSubject')) as Setting).stringValue;
            const body = ((await this.uow.getSettingsByName('AchEmailBody')) as Setting).stringValue;
            this.email.achId = this.entityId;
            this.email.subject = subject;
            this.email.body = `${body}\n\n${this.body}`;
        } else {
            // mode === SalesOrder
            this.entity = await this.uow.orders.byId(this.entityId, 'dealer, salesRep');
            this.email.salesOrderId = this.entityId;
            if (this.emailConfirmation && this.entity.shipToEmail) this.email.to += `${this.email.to ? ', ' : ''}${this.entity.shipToEmail}`;
            this.email.subject = `${this.isQuote ? 'Quote #' : 'Sales Order #'}${this.entity.invoiceNumber}${this.emailConfirmation ? ' PLEASE CONFIRM' : ''}`;
            this.email.body = this.body;
            if (this.emailConfirmation) {
                this.email.body = `<p>${this.body}<p>`;
                this.includeConfirmation = true;
                this.selectedType = this.types.find((t) => t.name === 'Confirmation')?.id;
                this.getConfirmationDetails();
            }
            this.email.cc = this.entity.salesRep?.sendSalesOrders ? this.entity.salesRep.email : '';
            this.sendCCTheirOwnEmail = true;
        }
    }

    getConfirmationDetails() {
        if (this.order.dealer?.channelPartner) {
            this.selectedMessage = _.orderBy(
                this.messages.filter((m) => m.isChannelPartnerMessage),
                ['id'],
                ['desc'],
            )[0] as ConfirmationMessage;
            return;
        }
        if (this.order.noPrePay) {
            const messages = this.messages.filter((m) => m.isNoPrePayMessage);
            this.selectedMessage = _.orderBy(messages, ['id'], ['desc'])[0] as ConfirmationMessage;
            return;
        }
        const messages = this.messages.filter((m) => m.isDefaultMessage);
        if (messages.length > 0) {
            this.selectedMessage = _.orderBy(messages, ['id'], ['desc'])[0] as ConfirmationMessage;
            return;
        }
    }

    enterPressed() {
        // if (this.mode !== 'textarea') this.save();
    }
    addAddress() {
        if (!!this.selectedAddress) this.email.to += `${this.email.to ? ', ' : ''}${this.selectedAddress}`;
    }

    async save() {
        const success = this.validate();
        if (!success) return;

        this.processing = true;
        let ccEmail = null;

        if (this.mode === 'SalesOrder' && !this.includeConfirmation && this.emailConfirmation) {
            const success = await confirm('Confirmation was not included. Do you still want to send?', this.appInfo.settings.company);
            if (!success) {
                this.processing = false;
                return;
            }
        }

        this.appInfo.pleaseWaitShow();
        if (this.includeConfirmation) {
            if (this.sendCCTheirOwnEmail && this.email.cc) {
                ccEmail = this.duplicateEmailMessage();
                this.prependDealerAddresses(ccEmail, this.email.to);
                ccEmail.to = ccEmail.cc;
                ccEmail.cc = null;
                this.email.cc = null;
                const ccConfirmation = this.createConfirmation();
                ccConfirmation.salesRepConfirmation = true;
                const ccConfirmationUrl = this.portalService.getConfirmationUrl(ccConfirmation);
                this.addConfirmationUrl(ccEmail, ccConfirmationUrl);
            }

            const dealerConfirmation = this.createConfirmation();
            const dealerConfirmationUrl = this.portalService.getConfirmationUrl(dealerConfirmation);
            this.addConfirmationUrl(this.email, dealerConfirmationUrl);
        }

        if (this.saveEmailOnlyOnSend) await this.uow.commit([this.email]);
        else await this.uow.commit();

        this.appInfo.pleaseWaitHide();

        this.result.next({ success: true, value: this.email.id, ccEmailId: ccEmail?.id, attachInvoices: this.attachInvoices });
    }

    createConfirmation() {
        return this.uow.confirmations.createEntity({
            code: core.getUuid(),
            typeId: this.selectedType,
            dealerId: this.entity.dealerId,
            orderId: this.entityId,
            messageName: this.selectedMessage.name,
            message: this.selectedMessage.message,
            message2: this.selectedMessage.message2,
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
        }) as Confirmation;
    }

    duplicateEmailMessage() {
        return this.uow.emailMessages.createEntity({
            invoiceId: this.email.invoiceId,
            to: this.email.to,
            subject: this.email.subject,
            body: this.email.body,
            created: new Date(),
            createdById: this.auth.currentUser.id,
            salesOrderId: this.email.salesOrderId,
            purchaseOrderId: this.email.purchaseOrderId,
            cc: this.email.cc,
            bcc: this.email.bcc,
        }) as EmailMessage;
    }

    prependDealerAddresses(message: EmailMessage, addresses: string) {
        if (!addresses) return;
        const splitAddresses = addresses.split(/;|,/); // regex for semicolon and comma
        let prepend = 'Dealer Email Addresses:';
        splitAddresses.forEach((address) => {
            if (!address) return;
            prepend = prepend + `\n\t• ${address.trim()}`;
        });

        message.body = `${prepend}\n\n${message.body}`;
    }

    addConfirmationUrl(email: EmailMessage, url: string) {
        email.body =
            `Confirmation Link: <a href="${url}">${url}</a>\r\n\r\n` +
            email.body +
            `<p>Click the button below to confirm your order:</p>
            <a href="${url}" 
            style="display:inline-block; padding:10px 20px; background:#0078D7; color:#fff; 
            text-decoration:none; border-radius:5px;">
            Start Order Confirmation
            </a>`;
        email.mode = 'Confirmation';
    }

    cancel() {
        this.uow.rollback();
        this.close();
    }

    close() {
        this.result.next({ success: false });
    }

    async getAttachments() {
        this.attachments = await this.uow.getEmailAttachments(this.email.id);
    }

    uploadStarted(e) {
        this.appInfo.pleaseWaitShow();
    }

    async uploaded(e) {
        if (e?.request?.responseText) {
            const fileResponses = JSON.parse(e.request.responseText) as { filename: string; name: string }[];
            fileResponses.forEach((fileResponse) => {
                let attachment = this.uow.emailAttachments.createEntity({
                    emailMessageId: this.email.id,
                    name: fileResponse.name,
                    filename: fileResponse.filename,
                    created: new Date(),
                    createdBy: this.auth.currentUser.userName,
                }) as EmailAttachment;
                this.attachments.push(attachment);
            });
            this.attachments = _(this.attachments).orderBy('name').valueOf();
        }
        this.appInfo.pleaseWaitHide();
    }

    uploadError(e) {
        alert('An error occurred while attempting to upload the file(s)', 'Upload Error');
    }

    removeAttachment(e, attachment: EmailAttachment) {
        e.preventDefault();
        if (this.mode === 'PurchaseOrder') {
            attachment.deleted = new Date();
            attachment.deletedBy = this.auth.currentUser.userName;
        }
        this.attachments.splice(this.attachments.indexOf(attachment), 1);
    }

    openAttachment(attachment: EmailAttachment) {
        let fileName = attachment.filename.replace(this.attachmentFullPath, '');
        const fileNameURI = encodeURIComponent(fileName);
        window.open(this.attachmentFullPath + fileNameURI, '_blank');
    }

    async openReport() {
        if (this.mode === 'PurchaseOrder') {
            const purchaseOrder = (await this.uow.purchaseOrders.byId(this.email.purchaseOrderId)) as PurchaseOrder;
            this.reportService.openPurchaseOrderReport(purchaseOrder.reportGuid);
        } else if (this.mode === 'SalesOrder') {
            const order = (await this.uow.orders.byId(this.email.salesOrderId)) as Order;
            if (!order.orderGuid) {
                order.orderGuid = crypto.randomUUID();
                await this.uow.commit([order]);
            }
            this.reportService.openSalesReport([order.orderGuid]);
        } else if (this.mode === 'PackingSlip') {
            const invoice = (await this.uow.packingSlips.byId(this.email.invoiceId)) as PackingSlip;
            this.reportService.openInvoiceWithBalanceReport([invoice.reportGuid]);
        } else if (this.mode === 'Invoice') {
            const invoice = (await this.uow.invoices.byId(this.email.invoiceId)) as Invoice;
            this.reportService.openInvoiceWithBalanceReport([invoice.reportGuid]);
        } else if (this.mode === 'SalesOrderMsrps') {
            const order = (await this.uow.orders.byId(this.email.salesOrderId, 'orderLines.orderLineDetails')) as any;
            let ids = [];
            order.orderLines.forEach((line) => {
                line.orderLineDetails?.forEach((detail) => {
                    ids.push(detail.id);
                });
            });
            this.reportService.openMsrpReport(ids);
        } else if (this.mode === 'ACH') {
            const ach = (await this.uow.aches.byId(this.email.achId)) as Ach;
            this.reportService.printAchAuthFormReport(ach.code);
        }
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before sending.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
